import React from "react";

const LuxuryInterior = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">Luxury Interior Cleaning</p>
        <ul className="list-disc text-black-500 ">
        <li className="font-bold">DashBoard & Interior Premium Polish</li>
        <li className="font-bold">Interior Foam Wash</li>
        <li className="font-bold">Free Paper Mat</li>
        <li className="font-bold">Free Air Freshener</li>
        <li className="font-bold">Interior Vacuum Cleaning</li>
          <li className="font-bold">Seat Cleaning</li>
          <li className="font-bold">Carpet & Floor Mat Cleaning</li>
        </ul>
      </div>
    </div>
  );
};

export default LuxuryInterior;

